import React from 'react';
import { createPortal } from 'react-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FiEdit2, FiTrash2, FiPlus } from 'react-icons/fi';
import '../../../../assets/css/admin/dashboard/ServicesManagement.css';
import AdminLayout from '../../../../layouts/admin/AdminLayout';

const Services = () => {

  const services = [
    { id: 1, service: 'DJ & Sound System',    category: 'Entertainment', price: 'PKR 45,000'  },
    { id: 2, service: 'Stage Lighting',        category: 'Decor',         price: 'PKR 35,000'  },
    { id: 3, service: 'Floral Decoration',     category: 'Decor',         price: 'PKR 80,000'  },
    { id: 4, service: 'Photography & Cinema',  category: 'Media',         price: 'PKR 120,000' },
    { id: 5, service: 'Premium Catering',      category: 'Food',          price: 'PKR 1,800'   },
    { id: 6, service: 'Bridal Mehndi',         category: 'Beauty',        price: 'PKR 25,000'  },
    { id: 7, service: 'Bridal Makeup',         category: 'Beauty',        price: 'PKR 65,000'  },
    { id: 8, service: 'Wedding Car',           category: 'Transport',     price: 'PKR 30,000'  },
  ];

  const [sgcShowAdd,  setSgcShowAdd]  = React.useState(false);
  const [sgcShowEdit, setSgcShowEdit] = React.useState(false);

  return (
    <AdminLayout>
      <div className="svc-wrapper">
        <Container fluid>

          {/* HEADER */}
          <div className="svc-header">
            <div>
              <h2 className="svc-title">Services</h2>
              <p className="svc-subtitle">Manage all add-on services.</p>
            </div>
            <button className="svc-add-btn" onClick={() => setSgcShowAdd(true)}>
              <FiPlus size={15} /> Add New
            </button>
          </div>

          {/* TABLE CARD */}
          <Row>
            <Col xs={12}>
              <div className="svc-card">
                <div className="table-responsive">
                  <table className="svc-table">
                    <thead>
                      <tr>
                        <th>Service</th>
                        <th>Category</th>
                        <th>Price</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {services.map((s) => (
                        <tr key={s.id}>
                          <td className="svc-name">{s.service}</td>
                          <td className="svc-category">{s.category}</td>
                          <td className="svc-price">{s.price}</td>
                          <td>
                            <div className="svc-actions">
                              <button className="svc-edit-btn" onClick={() => setSgcShowEdit(true)}>
                                <FiEdit2 />
                              </button>
                              <button className="svc-delete-btn">
                                <FiTrash2 />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          </Row>

        </Container>
      </div>

      {/* ADD MODAL */}
      {sgcShowAdd && createPortal(
        <div className="svc-modal-overlay" onClick={() => setSgcShowAdd(false)}>
          <div className="svc-modal-box" onClick={(e) => e.stopPropagation()}>

            <div className="svc-modal-header">
              <div>
                <h5 className="svc-modal-title">Add New Service</h5>
                <p className="svc-modal-subtitle">Fill in the details to create a new service.</p>
              </div>
              <button className="svc-modal-close" onClick={() => setSgcShowAdd(false)}>×</button>
            </div>

            <div className="svc-modal-body">
              <div className="svc-form-group">
                <label className="svc-form-label">Service</label>
                <input className="svc-form-input svc-input-focus" type="text" placeholder="Service" />
              </div>
              <div className="svc-form-group">
                <label className="svc-form-label">Category</label>
                <input className="svc-form-input" type="text" placeholder="Category" />
              </div>
              <div className="svc-form-group">
                <label className="svc-form-label">Price</label>
                <input className="svc-form-input" type="text" placeholder="Price" />
              </div>
            </div>

            <div className="svc-modal-footer">
              <button className="svc-modal-cancel-btn" onClick={() => setSgcShowAdd(false)}>Cancel</button>
              <button className="svc-modal-save-btn">Create</button>
            </div>

          </div>
        </div>,
        document.body
      )}

      {/* EDIT MODAL */}
      {sgcShowEdit && createPortal(
        <div className="svc-modal-overlay" onClick={() => setSgcShowEdit(false)}>
          <div className="svc-modal-box" onClick={(e) => e.stopPropagation()}>

            <div className="svc-modal-header">
              <div>
                <h5 className="svc-modal-title">Edit Service</h5>
                <p className="svc-modal-subtitle">Update the details of this service.</p>
              </div>
              <button className="svc-modal-close" onClick={() => setSgcShowEdit(false)}>×</button>
            </div>

            <div className="svc-modal-body">
              <div className="svc-form-group">
                <label className="svc-form-label">Service</label>
                <input className="svc-form-input svc-input-focus" type="text" placeholder="Service" />
              </div>
              <div className="svc-form-group">
                <label className="svc-form-label">Category</label>
                <input className="svc-form-input" type="text" placeholder="Category" />
              </div>
              <div className="svc-form-group">
                <label className="svc-form-label">Price</label>
                <input className="svc-form-input" type="text" placeholder="Price" />
              </div>
            </div>

            <div className="svc-modal-footer">
              <button className="svc-modal-cancel-btn" onClick={() => setSgcShowEdit(false)}>Cancel</button>
              <button className="svc-modal-save-btn">Update</button>
            </div>

          </div>
        </div>,
        document.body
      )}

    </AdminLayout>
  );
};

export default Services;